import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    more: translate({ id: 'global.more' }),
    filter: translate({ id: 'global.filter' }),
    selectAll: translate({ id: 'global.selectAll' }),
    deselectAll: translate({ id: 'global.deselectAll' }),
  }))

  return api
}
